import { render, staticRenderFns } from "./NotificationConfig.vue?vue&type=template&id=0f2d4bc0"
import script from "./NotificationConfig.vue?vue&type=script&lang=js"
export * from "./NotificationConfig.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfig.vue?vue&type=style&index=0&id=0f2d4bc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports